import { createRoutine } from 'redux-saga-routines';

export const getCourse = createRoutine('GET_COURSE');
export const getCourses = createRoutine('GET_COURSES');
export const enrolCourse = createRoutine('ENROL_COURSE');
export const verifyCourseEnrolment = createRoutine('VERIFY_COURSE_ENROLMENT');
export const disputeCourseEnrolment = createRoutine('DISPUTE_COURSE_ENROLMENT');
